
import { Row, Col, Card, Form, InputGroup } from 'react-bootstrap';
import { FaUser } from 'react-icons/fa';

const CustomerInfoCard = ({ formData, originalValues, formatCurrency, onInputChange }) => {
  return (
    <Card className="border-0 shadow-sm mb-4">
      <Card.Header className="bg-white border-0 py-3">
        <h5 className="mb-0 fw-bold">
          <FaUser className="me-2" />
          Customer Information
        </h5>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Customer Name *</Form.Label>
              <Form.Control
                type="text"
                name="eventDetails.name"
                value={formData.eventDetails.name}
                onChange={onInputChange}
                required
              />
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>CNIC</Form.Label>
              <Form.Control
                type="text"
                name="eventDetails.cnic"
                value={formData.eventDetails.cnic}
                onChange={onInputChange}
              />
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Event Date</Form.Label>
              <Form.Control
                type="date"
                name="eventDetails.dateOfEvent"
                value={formData.eventDetails.dateOfEvent}
                onChange={onInputChange}
              />
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Day of Event</Form.Label>
              <Form.Select
                name="eventDetails.dayOfEvent"
                value={formData.eventDetails.dayOfEvent}
                onChange={onInputChange}
              >
                <option value="">Select Day</option>
                <option value="monday">Monday</option>
                <option value="tuesday">Tuesday</option>
                <option value="wednesday">Wednesday</option>
                <option value="thursday">Thursday</option>
                <option value="friday">Friday</option>
                <option value="saturday">Saturday</option>
                <option value="sunday">Sunday</option>
              </Form.Select>
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Total Persons *</Form.Label>
              <Form.Control
                type="number"
                name="eventDetails.persons"
                value={formData.eventDetails.persons}
                onChange={onInputChange}
                min="1"
                required
              />
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Venue</Form.Label>
              <Form.Control
                type="text"
                name="eventDetails.venue"
                value={formData.eventDetails.venue}
                onChange={onInputChange}
              />
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Per Head Rate</Form.Label>
              <InputGroup>
                <InputGroup.Text>Rs</InputGroup.Text>
                <Form.Control
                  type="number"
                  name="perHead"
                  value={formData.perHead}
                  onChange={onInputChange}
                  min="0"
                />
              </InputGroup>
              
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Service Type</Form.Label>
              <Form.Select
                name="serviceType"
                value={formData.serviceType}
                onChange={onInputChange}
              >
                <option value="">Select Type</option>
                <option value="Table">Table</option>
                <option value="Buffet">Buffet</option>
                <option value="Box">Box</option>
                <option value="Plate">Plate</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Lunch / Dinner</Form.Label>
              <Form.Select
                name="eventDetails.lunchDinner"
                value={formData.eventDetails.lunchDinner}
                onChange={onInputChange}
              >
                <option value="">Select</option>
                <option value="Lunch">Lunch</option>
                <option value="Dinner">Dinner</option>
              </Form.Select>
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Original Advance</Form.Label>
              <InputGroup>
                <InputGroup.Text>Rs</InputGroup.Text>
                <Form.Control
                  type="number"
                  name="eventDetails.advancePayment"
                  value={formData.eventDetails.advancePayment}
                  onChange={onInputChange}
                  min="0"
                  readOnly
                  className="bg-light"
                />
              </InputGroup>
              
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Mobile 1</Form.Label>
              <Form.Control
                type="text"
                name="eventDetails.mob1"
                value={formData.eventDetails.mob1}
                onChange={onInputChange}
              />
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Mobile 2</Form.Label>
              <Form.Control
                type="text"
                name="eventDetails.mob2"
                value={formData.eventDetails.mob2}
                onChange={onInputChange}
              />
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Bill Status</Form.Label>
              <div className="mt-2">
                <Form.Select
                  name="status"
                  value={formData.status}
                  onChange={onInputChange}
                >
                  <option value="pending">Pending</option>
                  <option value="confirmed">Confirmed</option>
                  <option value="paid">Paid</option>
                  <option value="cancelled">Cancelled</option>
                </Form.Select>
              </div>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CustomerInfoCard;